import React, { useState } from "react";
import { useQuery } from "@apollo/react-hooks";
import { GET_ROTAS } from "../../queries/rota.query";
import { NavLink } from "react-router-dom";
import RotasList from "./partials/RotasList";
import Pagination from "../../partials/pagination";
import LoadingSpinner from "../../partials/loading";
import { toast } from "react-toastify";
import { CleanMessage } from "../../util/app";
import { EventEmitter } from "../../event/EventEmitter";
import { EVENT_TARGET } from "../../event/model";

const RotaList = ({ location }) => {
    const [page, setPage] = useState(1);
    const [limit] = useState(30);
    const { loading, data, fetchMore, refetch } = useQuery(GET_ROTAS, {
        variables: { page, limit },
        onError: (e) => toast.error(CleanMessage(e.message)),
        notifyOnNetworkStatusChange: true,
    });
    EventEmitter.subscribe(EVENT_TARGET.ROTA, () => refetch());
    return (
        <div className="row justify-content-center">
            <div className="col-md-12 text-center">
                <NavLink className="mdl-button mdl-button--raised mdl-js-ripple-effect m-b-10 margin-right-10 btn-circle btn-default" to={{ pathname: "/home/clinical-note/ward-summary" }}>
                    <i className="material-icons">arrow_back</i> Back Home
                </NavLink>
                <NavLink className="mdl-button mdl-button--raised mdl-js-ripple-effect m-b-10 btn-circle text-success" to={{ pathname: "/home/rota" }}>
                    <i className="material-icons">people_outline</i> Staff on Duty
                </NavLink>
            </div>
            <div className="col-md-11">
                <div className="card">
                    <div className="card-head">
                        <header>Rota List</header>
                        <div className="tools">
                            <a className="t-collapse btn-color fa fa-chevron-down" href="javascript:;"></a>
                        </div>
                    </div>
                    <div className="card-body m-b-20" style={{ minHeight: "520px" }}>
                        {loading && <LoadingSpinner loading={loading} />}
                        {data && <RotasList rotas={data.GetRotas.docs} location={location} />}
                        {data && (
                            <Pagination
                                {...data.GetRotas}
                                length={data.GetRotas.docs.length}
                                onPageClicked={async (page) => {
                                    setPage(page);
                                    await fetchMore({
                                        variables: { page },
                                        updateQuery: (prev, { fetchMoreResult }) => {
                                            if (!fetchMoreResult) return prev;
                                            return {
                                                GetRotas: fetchMoreResult.GetRotas,
                                            };
                                        },
                                    });
                                }}
                            />
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RotaList;
